// extracted by mini-css-extract-plugin
export default {"homeConfigureTitle":"Title_homeConfigureTitle__DzUez"};